import EnquiryPageShell from '@/components/feature/EnquiryPageShell';
import EnquiryForm from '@/components/feature/EnquiryForm';

export default function PersonalMatch() {
  return (
    <EnquiryPageShell
      eyebrow="Personal Match — Free"
      title="Find My Match"
      intro={
        <>
          <p>
            Tell us what you need. If we have a suitable match in our existing network, we&rsquo;ll
            personally introduce you.
          </p>
          <p>
            This free service works from our existing network only. It does not include extensive new
            research, and a match cannot be guaranteed.
          </p>
        </>
      }
    >
      <EnquiryForm
        submitAddr="https://readdy.ai/api/form/db6hqckbe24agvuu3jpg"
        formId="personal_match"
        categoryMode="single"
        submitLabel="Send My Request"
        successMessage="Thank you — your request has been received for Daniella's review. She'll be in touch if there's a suitable match in the network."
      />
    </EnquiryPageShell>
  );
}